import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const WORKSPACE_ITEMS = [
  {
    label: 'Dashboard',
    path: '/',
    exact: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
  },
  {
    label: 'Portfolio Health',
    path: '/portfolio',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    label: 'Reports',
    path: '/reports',
    premiumOnly: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
  {
    label: 'Backlog AI',
    path: '/backlog',
    roles: ['owner', 'admin', 'superadmin'],
    premiumOnly: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    ),
  },
  {
    label: 'About',
    path: '/about',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    ),
  },
];

const SYSTEM_ITEMS = [
  {
    label: 'Configuration',
    path: '/config',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
  },
  {
    label: 'Users',
    path: '/admin/users',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    label: 'Analytics',
    path: '/admin/analytics',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
  },
  {
    label: 'Insight Compare',
    path: '/admin/insights/compare',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="7" height="16" rx="1"/><rect x="14" y="4" width="7" height="16" rx="1"/>
      </svg>
    ),
  },
  {
    label: 'Rubrics',
    path: '/admin/rubrics',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4"/>
        <path d="M9 3v18"/><path d="M13 8h4"/><path d="M13 12h4"/><path d="M13 16h4"/>
      </svg>
    ),
  },
  {
    label: 'Audit Log',
    path: '/admin/audit-log',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    ),
  },
  {
    label: 'Feedback',
    path: '/admin/feedback',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    label: 'Tenants',
    path: '/admin/tenants',
    superadminOnly: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>
        <line x1="9" y1="9" x2="9" y2="9.01"/><line x1="9" y1="13" x2="9" y2="13.01"/>
        <line x1="9" y1="17" x2="9" y2="17.01"/>
      </svg>
    ),
  },
  {
    label: 'Insight Quality',
    path: '/admin/quality',
    superadminOnly: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
  },
];

function NavItem({ item, isActive, isFree, onNavigate }) {
  return (
    <Link
      to={item.premiumOnly && isFree ? '/upgrade' : item.path}
      onClick={onNavigate}
      className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors no-underline ${
        isActive
          ? 'bg-[#1A2E45] text-white'
          : 'text-[#E5C07B] hover:text-white hover:bg-[#1A2E45]'
      }`}
    >
      <span className={isActive ? 'text-[#00C2A8]' : 'text-[#E5C07B]'}>{item.icon}</span>
      <span>{item.label}</span>
      {item.premiumOnly && isFree && (
        <span className="ml-auto px-1.5 py-0.5 text-[9px] font-bold rounded bg-[#E0F9F6] text-[#009987]">PRO</span>
      )}
    </Link>
  );
}

export default function Sidebar({ user, open = false, onClose }) {
  const location = useLocation();
  const isExpiredTrial = user?.plan === 'trial' && user?.trial_days_remaining <= 0;
  const isFree = user?.plan === 'free' || isExpiredTrial;

  // CVA-83: on mobile the sidebar is an overlay drawer; on md+ it is static.
  const handleNavigate = () => { if (onClose) onClose(); };

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    return location.pathname.startsWith(item.path);
  };

  const visibleWorkspace = WORKSPACE_ITEMS.filter(
    item => !item.roles || item.roles.includes(user?.role) || (item.premiumOnly && isFree)
  );

  return (
    <>
      {/* Mobile backdrop — click to close the drawer */}
      {open && (
        <div
          data-testid="sidebar-backdrop"
          onClick={onClose}
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          aria-hidden="true"
        />
      )}

      <aside
        data-testid="sidebar-drawer"
        className={`fixed inset-y-0 left-0 z-50 flex w-52 bg-[#0D1B2A] border-r border-[#243B55] flex-col shrink-0 transition-transform duration-200 ease-in-out md:static md:z-auto md:translate-x-0 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Logo + mobile close button */}
        <div className="px-4 py-4 border-b border-[#243B55] flex items-center justify-between">
          <Link to="/" onClick={handleNavigate} className="flex items-center gap-2 no-underline">
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <polygon points="16,3 27,9.6 27,22.4 16,29 5,22.4 5,9.6" stroke="#00C2A8" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
              <line x1="16" y1="16" x2="16" y2="8.6" stroke="#00C2A8" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="16" y1="16" x2="22.4" y2="12.3" stroke="#00C2A8" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="16" y1="16" x2="9.6" y2="12.3" stroke="#00C2A8" strokeWidth="1.5" strokeLinecap="round"/>
              <circle cx="16" cy="16" r="2" fill="#00C2A8"/>
            </svg>
            <span className="text-base font-bold text-white" style={{ fontFamily: 'Syne, sans-serif' }}>
              Omnio <span className="text-[#00C2A8]">View</span>
            </span>
          </Link>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close menu"
            className="md:hidden text-[#E5C07B] hover:text-white p-1 -mr-1"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-2 pt-3 space-y-0.5 overflow-y-auto">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-[#E5C07B] px-2 pb-1">Workspace</p>
          {visibleWorkspace.map(item => (
            <NavItem key={item.path} item={item} isActive={isActive(item)} isFree={isFree} onNavigate={handleNavigate} />
          ))}

          {(user?.role === 'admin' || user?.role === 'superadmin') && (user?.role === 'superadmin' || !isFree) && (
            <>
              <p className="text-[10px] font-semibold uppercase tracking-widest text-[#E5C07B] px-2 pt-4 pb-1">System</p>
              {SYSTEM_ITEMS.filter(item => !item.superadminOnly || user?.role === 'superadmin').map(item => (
                <NavItem key={item.path} item={item} isActive={isActive(item)} onNavigate={handleNavigate} />
              ))}
            </>
          )}
        </nav>
      </aside>
    </>
  );
}
